import { Col, Row } from "@zendeskgarden/react-grid";
import { Message } from "@zendeskgarden/react-forms";
import React from "react";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router";
import Loading from "../../../../components/loading";
import { LOGIN_ROUTE } from "../../../../providers/routes";
import { AuthenticationService } from "../../../../services/auth.service";
import OpportunityService from "../../../../services/opportunity.service";
import { t } from "../../../../translations/translation.service";
import ApplicationFormAnswersList, {
  ApplicationFormCandidateAnswers as CandidateAnswers,
  ApplicationFormScore,
} from "../../../../components/application-form-answers";
import style from "./index.module.scss";

class OpportunityApplicationFormAnswers extends React.Component<any> {
  state = {
    loading: true,
    error: "",
    opportunityTitle: "",
    candidates: [] as CandidateAnswers[],
    expanded: [] as string[],
  };

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps: any) {
    if (prevProps.currentLanguage !== this.props.currentLanguage) {
      this.load();
    }
  }

  load() {
    const id = this.props.match.params.id;
    if (!id) {
      this.setState({ loading: false, error: t("Vaga não encontrada") });
      return;
    }

    this.setState({ loading: true });
    OpportunityService.getApplicationFormAnswers(id)
      .then((response) => {
        this.setState({
          loading: false,
          opportunityTitle: response.data.opportunityTitle || "",
          candidates: response.data.candidates || [],
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ loading: false, error: t("ErroCarregarRespostas") });
      });
  }

  toggleCandidate(professionalId: string) {
    this.setState((prevState: any) => ({
      expanded: prevState.expanded.includes(professionalId)
        ? prevState.expanded.filter((id: string) => id !== professionalId)
        : [...prevState.expanded, professionalId],
    }));
  }

  renderCandidate(candidate: CandidateAnswers) {
    const isExpanded = this.state.expanded.includes(candidate.professionalId);

    return (
      <div className={style["candidate-card"]} key={candidate.professionalId}>
        <Row>
          <Col sm={8}>
            <div className={style["candidate-name"]}>
              <a
                href={`/opportunity/${this.props.match.params.id}/professionals?level=candidates`}
                target="_blank"
                rel="noopener noreferrer"
                className={style["candidate-link"]}
              >
                {candidate.name}
              </a>
            </div>
            <div className={style["candidate-email"]}>{candidate.email}</div>
          </Col>
          <Col sm={4} className="text-right">
            <ApplicationFormScore score={candidate.score} />
            <Button
              className={style["link-button"]}
              onClick={() => this.toggleCandidate(candidate.professionalId)}
            >
              {isExpanded ? t("OcultarRespostas") : t("VerRespostas")}
            </Button>
          </Col>
        </Row>
        {isExpanded && <ApplicationFormAnswersList items={candidate.items} />}
      </div>
    );
  }

  render() {
    if (!AuthenticationService.canViewApplicationFormAnswers()) {
      return <Redirect to={LOGIN_ROUTE} />;
    }

    if (this.state.loading) {
      return <Loading show={true} />;
    }

    return (
      <div className={style["container"]}>
        <h1 className={style["title"]}>{t("RespostasFormularioCandidatura")}</h1>
        <h2 className={style["subtitle"]}>{this.state.opportunityTitle}</h2>

        {this.state.error && <Message validation="error">{this.state.error}</Message>}

        {!this.state.error && this.state.candidates.length === 0 && (
          <div>{t("NenhumCandidatoRespondeu")}</div>
        )}

        {this.state.candidates.map((candidate) => this.renderCandidate(candidate))}
      </div>
    );
  }
}

const mapStateToProps = (store: {
  changeLanguageReducer: { currentLanguage: string };
}) => ({
  currentLanguage: store.changeLanguageReducer.currentLanguage,
});

export default connect(mapStateToProps)(withRouter(OpportunityApplicationFormAnswers));
